/**
 * Editorial tabs — desktop hover + mobile click.
 *
 * @package HelloElementorChild
 */

function getTabTriggers(root) {
  return Array.prototype.slice.call(root.querySelectorAll('[data-camst-tabs-trigger]'));
}

function getTabPanels(root) {
  return Array.prototype.slice.call(root.querySelectorAll('[data-camst-tabs-panel]'));
}

function setActiveTab(root, index) {
  var triggers = getTabTriggers(root);
  var panels = getTabPanels(root);

  triggers.forEach(function (trigger) {
    var triggerIndex = parseInt(trigger.getAttribute('data-index') || '0', 10);
    var isActive = triggerIndex === index;

    trigger.classList.toggle('is-active', isActive);
    trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
  });

  panels.forEach(function (panel) {
    var panelIndex = parseInt(panel.getAttribute('data-index') || '0', 10);
    var isActive = panelIndex === index;

    panel.classList.toggle('is-active', isActive);

    if (isActive) {
      panel.removeAttribute('hidden');
    } else {
      panel.setAttribute('hidden', '');
    }
  });
}

export function initCamstTabs(scope) {
  var roots = [];

  if (!scope) {
    roots = Array.prototype.slice.call(document.querySelectorAll('[data-camst-tabs]'));
  } else if (scope.matches && scope.matches('[data-camst-tabs]')) {
    roots = [scope];
  } else {
    roots = Array.prototype.slice.call(scope.querySelectorAll('[data-camst-tabs]'));
  }

  roots.forEach(function (root) {
    if (root.dataset.camstTabsInit === '1') {
      return;
    }

    root.dataset.camstTabsInit = '1';

    var triggers = getTabTriggers(root);

    if (!triggers.length) {
      return;
    }

    triggers.forEach(function (trigger) {
      var index = parseInt(trigger.getAttribute('data-index') || '0', 10);
      var isDesktop = trigger.classList.contains('camst-tabs__trigger--desktop');

      trigger.addEventListener('click', function () {
        setActiveTab(root, index);
      });

      if (isDesktop) {
        trigger.addEventListener('mouseenter', function () {
          setActiveTab(root, index);
        });

        trigger.addEventListener('focus', function () {
          setActiveTab(root, index);
        });
      }
    });
  });
}

export function teardownCamstTabs(scope) {
  if (!scope) {
    return;
  }

  var roots = scope.matches && scope.matches('[data-camst-tabs]')
    ? [scope]
    : Array.prototype.slice.call(scope.querySelectorAll('[data-camst-tabs]'));

  roots.forEach(function (root) {
    delete root.dataset.camstTabsInit;
  });
}
